import { Component, OnInit, Inject } from '@angular/core';
import { UserService } from '../../../../../app/shared/services/user.service';
import { ManageEquipmentService } from '../../manage-equipment.service';
import { NotificationsService } from 'angular2-notifications';
import { LoadingService } from '../../../../../app/shared/services/loading.service';
import { AppService } from '../../../../../app/app.service';
import { PreferencesService } from '../../../../modules/preferences/preferences.service';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-track-frame-configuration',
  templateUrl: './track-frame-configuration.component.html',
  styleUrls: ['./track-frame-configuration.component.scss']
})
export class TrackFrameConfigurationComponent implements OnInit {

  SelectedType:number;
  selectedValue:number;
  title:string;
  ShowEdit:boolean=false;
  systemId:number;
  Editselected:boolean=false;
  _CannonType:number;
  _FrameConfig:number;
  //appUris: AppUris;
  isUpdate:boolean=false;
  equipmentId:number;
  inspectionId:number;
  side: number;
  trackvalue:number;
  screenId:number;
  constructor(private _user: UserService,
    private _equipment: ManageEquipmentService,
    public dialogRef: MatDialogRef<TrackFrameConfigurationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _notification: NotificationsService,  private _app: AppService,
    private _loading: LoadingService,
    private readonly _pref: PreferencesService,
    private _router: Router,
 ) { }

  ngOnInit() {
    this.SelectedType=this.data.selectedType;
    this.selectedValue=this.data.selectedValue;
    this.equipmentId=this.data.equipmentId;
    this.inspectionId = this.data?.inspectionId ?? 0;
    this.title= this.SelectedType==1?"Frame Configuration":"Cannon Type";
    this.systemId = this.data.systemId;
    this._CannonType=this.selectedValue;
    this._FrameConfig=this.selectedValue;
    this.side = this.data?.side ?? 0;
    this.screenId = this.data?.screenId ?? 0;
    //this._app.getAppUris().subscribe(result => { this.appUris = result; });
  }

  EditFramConfiguration(){
    this.Editselected=true
    this._CannonType=this.selectedValue;
    this._FrameConfig=this.selectedValue;
    this.isUpdate=true;
  }

  SaveFramConfiguration(){
    let value = this.trackvalue==1?true:false;
    if(this.trackvalue>0){
      console.log("this.inspectionId",this.inspectionId)
      this._equipment.updateTrackFrameConfiguration(this.systemId,value,this.SelectedType, this.inspectionId, this.side, this.screenId).subscribe(res=>{
        // this.dialogRef.close(this.trackvalue);
        this.dialogRef.close(this.trackvalue);
        this._notification.success('Saved','Update Track Frame Configuration.');
      });
    } 
  }

  onNoClick(): void {
    this.dialogRef.close(this.selectedValue);
  }

  recordaction(){
    this.dialogRef.close(this.selectedValue);
    //window.open(this.appUris.UCUri + 'record-actions/' + this.equipmentId, '_blank');
    this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
      if(res=="True"){
        //this._router.navigate([this.appUris.UCUri +'/record-actions', this.equipmentId]);
        this._router.navigate([this._app.getBaseURL() +'/record-actions', this.equipmentId]);
      }else{             
        //window.open(this.appUris.UCUri + 'record-actions/' + this.equipmentId, '_blank');
        window.open(this._app.getBaseURL() + 'record-actions/' + this.equipmentId, '_blank');
      }
    });
  }
  FrameConfigChange(event:any){
    this.trackvalue = event.value;
    let value = event.value==1?true:false;
    console.log("event_frame", event.value)
  }

  FrameCannonChange(event:any){
    let value = event.value==1?true:false;
    this.trackvalue = event.value;
    console.log("event_cannon", event.value)
  }
}